export default __webpack_public_path__ + "static/media/3-1-2.484dbb71.webp";